(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree1c8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree1c8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eYUK7", function(module, exports) {
const sizeChartButton = document.getElementById("size-chart-button");
const sizeChartDrawer = document.getElementById("size-chart--drawer");
const sizeChartCloseButton = document.getElementById("size-chart-drawer-close-button");
sizeChartButton?.addEventListener("click", ()=>{
    sizeChartDrawer.classList.toggle("is-open");
});
sizeChartCloseButton?.addEventListener("click", ()=>{
    sizeChartDrawer.classList.toggle("is-open");
});
const sizeChartContent = document.getElementById("size-chart-data")?.textContent;
const sizeChartData = JSON.parse(sizeChartContent);
console.log("\uD83D\uDE80 ~ sizeChartData:", sizeChartData);
const currentProductSizeData = findProductSizeData();
console.log("\uD83D\uDE80 ~ currentProductSizeData:", currentProductSizeData);
const table = document.getElementById("size-chart-table");
const currentVariant = getCurrentVariant();
console.log("\uD83D\uDE80 ~ currentVariant:", currentVariant);
let originalSizeUnit = "";
let sizeUnitPlacements = {};
if (currentProductSizeData && table) {
    buildHead();
    // buildVariantUnitButtons();
    buildBody();
    highlightCurrentVariant(currentVariant);
}
if (!currentProductSizeData && sizeChartButton) sizeChartButton.style.display = "none";
const drawer = document.querySelector("[data-component-id='size-chart-drawer']");
if (!drawer) return;
drawer.addEventListener("drawer-opened", function(event) {
    const currentVariant = getCurrentVariant();
    highlightCurrentVariant(currentVariant);
});
function findProductType() {
    const sizeChartContainer = document.getElementById("size-chart-container");
    const productType = sizeChartContainer.getAttribute("data-product-type")?.toLowerCase();
    const productTypeExtension = sizeChartContainer.getAttribute("data-product-type-extension")?.toLowerCase();
    if (productType && productTypeExtension) return `${productType}_${productTypeExtension}`;
    return productType;
}
function findProductSizeData() {
    const sizeChartContainer = document.getElementById("size-chart-container");
    if (!sizeChartContainer) return;
    const vendor = sizeChartContainer.getAttribute("data-vendor")?.toLowerCase();
    console.log("\uD83D\uDE80 ~ vendor:", vendor);
    const productType = findProductType();
    console.log("\uD83D\uDE80 ~ productType:", productType);
    let gender = sizeChartContainer.getAttribute("data-gender")?.toLowerCase();
    console.log("\uD83D\uDE80 ~ gender:", gender);
    try {
        if (vendor && productType && gender) {
            let currentProductSizeData = false;
            const productTypeBase = productType.split("_")[0];
            const vendorData = sizeChartData[vendor];
            if (vendorData) {
                const productTypeData = vendorData[productType] || vendorData[productTypeBase];
                if (productTypeData && productTypeData[gender]) currentProductSizeData = productTypeData[gender];
            }
            return currentProductSizeData;
        }
    } catch (error) {
        console.log("\uD83D\uDE80 ~ error:", error);
        return null;
    }
}
function sortProductSizeData(data) {
    //check if datakeys include slashes
    let includesSlashes = false;
    for(key in data){
        if (key.toLowerCase().includes("input") == false) {
            if (key != "" && key.toLowerCase().includes("/")) includesSlashes = true;
        }
    }
    // converting the size keys to floats so we can sort them if none of the keys include slashes
    let dataWithIntKeys = {};
    for(key in data)if (key != "" && key.toLowerCase().includes("input") == false && key != undefined) {
        let intKey = key;
        let intKeyData = {
            [intKey]: key
        };
        Object.assign(dataWithIntKeys, intKeyData);
    }
    const numericKeys = Object.keys(dataWithIntKeys).filter((key1)=>key1 !== "");
    const sortedNumericKeys = numericKeys.sort((a, b)=>parseFloat(a) - parseFloat(b));
    return sortedNumericKeys;
}
function buildHead() {
    const headers = getHeader(currentProductSizeData);
    const thead = table.querySelector("thead tr");
    if (!headers) return;
    for(let i = 0; i < headers.length; i++){
        const th = document.createElement("th");
        th.textContent = headers[i];
        thead.appendChild(th);
    }
}
function buildBody() {
    const body = getBody(currentProductSizeData);
    const tbody = table.querySelector("tbody");
    for (const row of body){
        if (!row) continue;
        const newRow = document.createElement("tr");
        for (const cell of row){
            const td = document.createElement("td");
            td.textContent = cell;
            newRow.appendChild(td);
        }
        tbody.appendChild(newRow);
    }
}
function getHeader(currentProductSizeData) {
    for(let key1 in currentProductSizeData)if (key1.toLowerCase().includes("input")) {
        originalSizeUnit = key1.toUpperCase().replace("INPUT_", "");
        return currentProductSizeData[key1];
    }
    return null; // or whatever default/fallback value you want
}
function getBody(currentProductSizeData) {
    const sorted_array = sortProductSizeData(currentProductSizeData);
    const array = sorted_array.map((key1)=>{
        console.log("\uD83D\uDE80 ~ key:", key1);
        return currentProductSizeData[key1];
    });
    return array;
}
function highlightCurrentVariant(currentVariant) {
    const tbody = table.querySelector("tbody");
    for (const row of tbody.rows){
        row.classList.remove("highlight");
        const firstCell = row.cells[0]?.textContent;
        console.log("\uD83D\uDE80 ~ firstCell:", firstCell);
        if (firstCell === currentVariant) row.classList.add("highlight");
    }
}
function getCurrentVariant() {
    const radioButtons = document.getElementsByName("options[Size]");
    let selectedValue;
    for(var i = 0; i < radioButtons.length; i++)if (radioButtons[i].checked) {
        selectedValue = radioButtons[i].value;
        break;
    }
    return selectedValue;
}
function buildVariantUnitButtons() {
    const headers = getHeader(currentProductSizeData);
    const sizeUnitSelectorWrapper = document.querySelector(".size-unit-selector-wrapper");
    if (!headers) return;
    for(let i = 0; i < headers.length; i++)if (!headers[i].toLowerCase().includes("input")) {
        const button = document.createElement("div");
        button.textContent = headers[i];
        button.classList.add("product-sizes__size");
        button.dataset.active = false;
        button.dataset.size = headers[i];
        if (i > 1) {
            const divider = document.createElement("span");
            divider.classList.add("divider");
            sizeUnitSelectorWrapper.appendChild(divider);
        }
        sizeUnitPlacements[headers[i]] = i;
        sizeUnitSelectorWrapper.appendChild(button);
    }
    document.querySelectorAll(".product-sizes__size").forEach((elm)=>{
        const unit = elm.dataset.size;
        elm.addEventListener("click", ()=>{
            selectSizeUnit(unit);
        });
    });
    selectSizeUnit(Object.keys(sizeUnitPlacements)[0]);
}
function selectSizeUnit(selectedSizeUnit) {
    document.querySelectorAll(".product-sizes__size").forEach((elm)=>{
        elm.dataset.active = false;
    });
    document.querySelector('.product-sizes__size[data-size="' + selectedSizeUnit + '"]').dataset.active = true;
    changeVariantUnits(selectedSizeUnit, sizeUnitPlacements);
}
function changeVariantUnits(selectedSizeUnit, sizeUnitPlacements) {
    let unitIndex = sizeUnitPlacements[selectedSizeUnit];
    document.querySelectorAll(".size-variants label").forEach((label)=>{
        const oriSize = label.dataset.originalSize;
        if (currentProductSizeData[oriSize]) label.innerText = currentProductSizeData[oriSize][unitIndex];
    });
}

});

parcelRegister("iZdAF", function(module, exports) {
const sliders = document.querySelectorAll(".product-grid-item__image--gallery");
if (!sliders.length) return;
const Flickity = themeVendor?.Flickity;
sliders.forEach((slider)=>{
    const items = slider.querySelectorAll(".product__media");
    if (items.length > 1) {
        const sl = new Flickity(slider, {
            wrapAround: true,
            pageDots: false
        });
    }
});

});

parcelRegister("6r3w3", function(module, exports) {
let countdownWrapper = document.querySelector(".product__block-countdown");
if (!countdownWrapper) return;
const countdownElement = document.getElementById("countdown");
const translatedHours = countdownElement?.getAttribute("data-countdown-ts-hours");
const translatedMinutes = countdownElement?.getAttribute("data-countdown-ts-minutes");
const translatedSeconds = countdownElement?.getAttribute("data-countdown-ts-seconds");
// Function to get the current time in Denmark's time zone
function getCurrentDanishTime() {
    // Use Denmark's time zone identifier ('Europe/Copenhagen')
    const denmarkTimeZone = "Europe/Copenhagen";
    const currentDate = new Date();
    // Create a date in Denmark's time zone
    const denmarkTime = new Date(currentDate.toLocaleString("en-US", {
        timeZone: denmarkTimeZone
    }));
    return denmarkTime;
}
// Function to check if today is a weekend (Saturday or Sunday)
function isWeekend() {
    const now = getCurrentDanishTime();
    const dayOfWeek = now.getDay(); // 0 = Sunday, 6 = Saturday
    return dayOfWeek === 0 || dayOfWeek === 6;
}
// Function to calculate time remaining until 14:00 Denmark time
function calculateTimeRemaining() {
    const now = getCurrentDanishTime();
    // Create a Date object for today at 14:00 in Denmark
    const endOfWorkDay = new Date(now);
    endOfWorkDay.setHours(14, 0, 0, 0); // Set the time to 14:00
    // If the current time is after 14:00, the shop is closed, so return 0
    if (now.getTime() > endOfWorkDay.getTime()) return 0;
    // Calculate the remaining time in milliseconds
    const timeRemaining = endOfWorkDay.getTime() - now.getTime();
    return timeRemaining;
}
// Function to format the time remaining in HHh MMm SSs
function formatTimeRemaining(milliseconds) {
    const hours = Math.floor(milliseconds / 3600000);
    const minutes = Math.floor(milliseconds % 3600000 / 60000);
    const seconds = Math.floor(milliseconds % 60000 / 1000);
    return `${hours}${translatedHours} ${minutes}${translatedMinutes} ${seconds}${translatedSeconds}`;
}
// Function to update the countdown timer
function updateCountdown() {
    const timeRemaining = calculateTimeRemaining();
    if (timeRemaining <= 0 || isWeekend()) {
        countdownWrapper.querySelector(".product__countdown--disabled")?.classList.add("show-delivery-message");
        countdownWrapper.querySelector(".product__countdown--active")?.classList.remove("show-delivery-message");
    } else {
        document.getElementById("countdown").innerText = formatTimeRemaining(timeRemaining);
        countdownWrapper.querySelector(".product__countdown--disabled")?.classList.remove("show-delivery-message");
        countdownWrapper.querySelector(".product__countdown--active")?.classList.add("show-delivery-message");
    }
}
// Call updateCountdown every second to keep the timer updated
setInterval(updateCountdown, 1000);

});

parcelRegister("kjMEF", function(module, exports) {
let cardNumber = document.querySelectorAll(".product-highlights__card");
if (!cardNumber.length) return;
const Flickity = themeVendor.Flickity;
function calculateAndIinitSliders() {
    var r = document.querySelector(":root");
    let desktopWidth = document.querySelector(".hidden-sm .section-columns__wrapper").getBoundingClientRect().width;
    let mobileWidth = document.querySelector(".mobile-only .section-columns__wrapper").getBoundingClientRect().width;
    r.style.setProperty("--desktopHighlightWidth", desktopWidth + "px");
    r.style.setProperty("--mobileHighlightWidth", mobileWidth + "px");
    const highlights = document.querySelectorAll(".section-columns__slider");
    highlights.forEach((highlight)=>{
        let flktyHighlight = new Flickity(highlight, {
            wrapAround: true,
            pageDots: false,
            adaptiveHeight: false,
            prevNextButtons: true,
            cellAlign: "left"
        });
    });
}
window.addEventListener("DOMContentLoaded", function() {
    calculateAndIinitSliders();
});
window.addEventListener("resize", function() {
    calculateAndIinitSliders();
});

});

parcelRegister("kGGAg", function(module, exports) {
parcelRequire("9Uhbu");
parcelRequire("cbaZd");
parcelRequire("64usJ");
if (!theme.settings.enableWishlist) return;

});
parcelRegister("9Uhbu", function(module, exports) {

var $3RGZ4 = parcelRequire("3RGZ4");

var $gf5lU = parcelRequire("gf5lU");

var $8pqPN = parcelRequire("8pqPN");

var $1DCAK = parcelRequire("1DCAK");

var $bw7V8 = parcelRequire("bw7V8");
class $7366ac7b5902cd9c$var$WishlistManager {
    constructor(){
        console.log("[Wishlist Manager] initialized");
        this.syncWishlists();
    }
    get localWishlist() {
        return (0, $3RGZ4.default)();
    }
    async syncWishlists() {
        if (!(0, $bw7V8.default).CUSTOMER_LOGGED_IN) return;
        const remoteWishlist = await (0, $gf5lU.default)() || [];
        const combinedWishlist = [
            ...new Set([
                ...this.localWishlist,
                ...remoteWishlist
            ])
        ];
        if (combinedWishlist.length === 0) return;
        this.updateLocalStorage(combinedWishlist);
        await this.syncRemoteWishlist(remoteWishlist);
    }
    updateLocalStorage(wishlist) {
        const wishlistString = wishlist.join((0, $bw7V8.default).LOCAL_STORAGE_DELIMITER);
        localStorage.setItem((0, $bw7V8.default).LOCAL_STORAGE_WISHLIST_KEY, wishlistString);
    }
    async syncRemoteWishlist(remoteWishlist) {
        const newWishlistItems = this.localWishlist.filter((productHandle)=>!remoteWishlist.includes(productHandle));
        if (newWishlistItems.length === 0) return;
        for (const productHandle of newWishlistItems){
            const productGid = await (0, $8pqPN.default)(productHandle);
            if (productGid) await (0, $1DCAK.default)(productGid);
        }
    }
}
new $7366ac7b5902cd9c$var$WishlistManager();

});
parcelRegister("3RGZ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d07aa0a829083a6$export$2e2bcd8739ae039);

var $bw7V8 = parcelRequire("bw7V8");
function $2d07aa0a829083a6$export$2e2bcd8739ae039() {
    const wishlist = localStorage.getItem((0, $bw7V8.default).LOCAL_STORAGE_WISHLIST_KEY);
    return wishlist ? wishlist.split((0, $bw7V8.default).LOCAL_STORAGE_DELIMITER) : [];
}

});
parcelRegister("bw7V8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8628d3b3067dd7dc$export$2e2bcd8739ae039);
const $8628d3b3067dd7dc$var$customerLoggedIn = window.customer?.isLoggedIn;
const $8628d3b3067dd7dc$var$customerId = window.customer?.id;
var $8628d3b3067dd7dc$export$2e2bcd8739ae039 = CONSTANTS = {
    LOCAL_STORAGE_WISHLIST_KEY: "wishlist",
    LOCAL_STORAGE_DELIMITER: ",",
    BUTTON_ACTIVE_CLASS: "is-active",
    CUSTOMER_LOGGED_IN: $8628d3b3067dd7dc$var$customerLoggedIn,
    CUSTOMER_ID: $8628d3b3067dd7dc$var$customerId,
    ALL_WISHLIST_URL: $8628d3b3067dd7dc$var$customerId ? `http://netlify.blacklemon.dk/.netlify/functions/getCustomerWishlistProducts?store=ny-form&customerId=${$8628d3b3067dd7dc$var$customerId}` : "",
    UPDATE_WISHLIST_URL: $8628d3b3067dd7dc$var$customerId ? `http://netlify.blacklemon.dk/.netlify/functions/updateCustomerWishlist?store=ny-form&customerId=${$8628d3b3067dd7dc$var$customerId}` : ""
};

});


parcelRegister("gf5lU", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd3232ea96ec629e$export$2e2bcd8739ae039);

var $bw7V8 = parcelRequire("bw7V8");
async function $bd3232ea96ec629e$export$2e2bcd8739ae039() {
    try {
        if (!(0, $bw7V8.default).CUSTOMER_LOGGED_IN) return [];
        const res = await fetch((0, $bw7V8.default).ALL_WISHLIST_URL);
        const data = await res.json();
        const products = data?.metafield?.value || [];
        return products;
    } catch (error) {
        console.error("[Wishlist] Failed to fetch wishlist", error);
        return [];
    }
}

});

parcelRegister("8pqPN", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f5794b789a2fa9$export$2e2bcd8739ae039);

var $3qHs0 = parcelRequire("3qHs0");
async function $61f5794b789a2fa9$export$2e2bcd8739ae039(handle) {
    try {
        const res = await fetch(`/products/${handle}.json`);
        if (res.ok) {
            const data = await res.json();
            const productId = data.product?.id;
            if (productId) return `gid://shopify/Product/${productId}`;
        } else {
            await (0, $3qHs0.default)(handle);
            console.info("[Wishlist] Product handle removed: ", handle);
            return null;
        }
    } catch (error) {
        console.error("[Wishlist] Failed to fetch product id", error);
        return null;
    }
}

});
parcelRegister("3qHs0", function(module, exports) {

$parcel$export(module.exports, "default", () => $27f581335186d45f$export$2e2bcd8739ae039);

var $bw7V8 = parcelRequire("bw7V8");
async function $27f581335186d45f$export$2e2bcd8739ae039(handle) {
    const wishlist = localStorage.getItem((0, $bw7V8.default).LOCAL_STORAGE_WISHLIST_KEY);
    const wishlistArray = wishlist ? wishlist.split((0, $bw7V8.default).LOCAL_STORAGE_DELIMITER) : [];
    const productIndex = wishlistArray.indexOf(handle);
    if (productIndex !== -1) {
        wishlistArray.splice(productIndex, 1);
        const wishlistString = wishlistArray.join((0, $bw7V8.default).LOCAL_STORAGE_DELIMITER);
        localStorage.setItem((0, $bw7V8.default).LOCAL_STORAGE_WISHLIST_KEY, wishlistString);
        const event = new CustomEvent("wishlist:removed", {
            detail: {
                handle: handle
            }
        });
        document.dispatchEvent(event);
    }
}

});


parcelRegister("1DCAK", function(module, exports) {

$parcel$export(module.exports, "default", () => $13175e778a734e00$export$2e2bcd8739ae039);

var $bw7V8 = parcelRequire("bw7V8");
async function $13175e778a734e00$export$2e2bcd8739ae039(gid) {
    if (!(0, $bw7V8.default).CUSTOMER_LOGGED_IN) return [];
    try {
        const res = await fetch((0, $bw7V8.default).UPDATE_WISHLIST_URL, {
            method: "POST",
            body: gid
        });
        const data = await res.json();
        const products = data.metafield.value;
        return products;
    } catch (error) {
        console.error("[Wishlist] Failed to update wishlist", error);
        return [];
    }
}

});


parcelRegister("cbaZd", function(module, exports) {

var $3RGZ4 = parcelRequire("3RGZ4");

var $8pqPN = parcelRequire("8pqPN");

var $1DCAK = parcelRequire("1DCAK");

var $bw7V8 = parcelRequire("bw7V8");
if (!customElements.get("wishlist-button")) {
    class WishlistButton extends HTMLElement {
        constructor(){
            super();
        }
        connectedCallback() {
            this.updateWishlistState(false);
            this.initializeEventListeners();
        }
        get button() {
            return this.querySelector("button");
        }
        get productHandle() {
            return this.button?.dataset.productHandle;
        }
        get localWishlist() {
            return (0, $3RGZ4.default)();
        }
        initializeEventListeners() {
            if (!this.button) return;
            this.button.disabled = false;
            if (!this.listenersAttached) {
                this.button.addEventListener("click", this.handleWishlistToggle.bind(this));
                this.listenersAttached = true;
            }
        }
        handleWishlistToggle() {
            this.updateWishlistState();
        }
        async updateWishlistState(shouldChangeState = true) {
            const wishlist = this.localWishlist;
            const productIndex = wishlist.indexOf(this.productHandle);
            let isActive = productIndex !== -1;
            if (shouldChangeState) {
                if (isActive) wishlist.splice(productIndex, 1);
                else wishlist.push(this.productHandle);
                isActive = !isActive; // Toggle the state
                this.saveWishlistToLocalStorage(wishlist);
                this.updateButtonAppearance(isActive);
                await this.syncRemoteWishlist();
            } else this.updateButtonAppearance(isActive);
        }
        saveWishlistToLocalStorage(wishlist) {
            const wishlistString = wishlist.join((0, $bw7V8.default).LOCAL_STORAGE_DELIMITER);
            localStorage.setItem((0, $bw7V8.default).LOCAL_STORAGE_WISHLIST_KEY, wishlistString);
        }
        async syncRemoteWishlist() {
            if ((0, $bw7V8.default).CUSTOMER_LOGGED_IN) {
                const productGid = await (0, $8pqPN.default)(this.productHandle);
                if (productGid) await (0, $1DCAK.default)(productGid);
            }
            document.dispatchEvent(new CustomEvent("wishlist:updated"));
        }
        updateButtonAppearance(isActive) {
            if (isActive) this.classList.add((0, $bw7V8.default).BUTTON_ACTIVE_CLASS);
            else this.classList.remove((0, $bw7V8.default).BUTTON_ACTIVE_CLASS);
        }
    }
    customElements.define("wishlist-button", WishlistButton);
}

});

parcelRegister("64usJ", function(module, exports) {

var $3RGZ4 = parcelRequire("3RGZ4");

var $dasZf = parcelRequire("dasZf");
if (!customElements.get("wishlist-page")) {
    class WishlistPage extends HTMLElement {
        constructor(){
            super();
        }
        connectedCallback() {
            this.setupGrid();
            this.setupEventListeners();
        }
        setupEventListeners() {
            document.addEventListener("wishlist:updated", this.setupGrid.bind(this));
        }
        get wishlistGrid() {
            return this.querySelector((0, $dasZf.default).WISHLIST_GRID);
        }
        async setupGrid() {
            if (!this.wishlistGrid) return;
            const wishlist = (0, $3RGZ4.default)();
            const requests = wishlist.map(this.fetchProductCardHTML);
            const responses = await Promise.all(requests);
            const wishlistProductCards = responses.join("");
            this.renderWishlistContent(wishlistProductCards);
        }
        renderWishlistContent(wishlistProductCards) {
            const wishlistEmpty = this.querySelector((0, $dasZf.default).WISHLIST_EMPTY);
            const wishlistNotEmpty = this.querySelector((0, $dasZf.default).WISHLIST_NOT_EMPTY);
            const wishlistGridWrapper = this.querySelector((0, $dasZf.default).WISHLIST_GRID_WRAPPER);
            if (wishlistProductCards) {
                if (wishlistEmpty) wishlistEmpty.classList.add("hidden");
                if (wishlistNotEmpty) wishlistNotEmpty.classList.remove("hidden");
                if (wishlistGridWrapper) wishlistGridWrapper.classList.remove("hidden");
                this.wishlistGrid.innerHTML = wishlistProductCards;
            } else {
                if (wishlistEmpty) wishlistEmpty.classList.remove("hidden");
                if (wishlistNotEmpty) wishlistNotEmpty.classList.add("hidden");
                if (wishlistGridWrapper) wishlistGridWrapper.classList.add("hidden");
                this.wishlistGrid.innerHTML = "";
            }
            const event = new CustomEvent("wishlist:render-content", {});
            document.dispatchEvent(event);
        }
        async fetchProductCardHTML(handle, index) {
            const productTileTemplateUrl = `/products/${handle}?view=product-grid-item`;
            try {
                const res = await fetch(productTileTemplateUrl);
                const res_2 = await res.text();
                const text = res_2;
                const parser = new DOMParser();
                const htmlDocument = parser.parseFromString(text, "text/html");
                const productCard = htmlDocument.documentElement.querySelector("[data-product-block]");
                if (productCard) return productCard.outerHTML;
            } catch (err) {
                return console.error(`[Wishlist] Failed to load content for handle: ${handle}`, err);
            }
        }
    }
    customElements.define("wishlist-page", WishlistPage);
}

});
parcelRegister("dasZf", function(module, exports) {

$parcel$export(module.exports, "default", () => $9962b1bcbda1f63e$export$2e2bcd8739ae039);
var $9962b1bcbda1f63e$export$2e2bcd8739ae039 = SELECTORS = {
    WISHLIST_REMOVE_CONFIRMATION_WRAPPER: ".remove-wishlist-confirmation",
    WISHLIST_REMOVE_CONFIRMATION_CONFIRM: ".remove-wishlist-confirmation--confirm",
    WISHLIST_REMOVE_CONFIRMATION_CANCEL: ".remove-wishlist-confirmation--cancel",
    WISHLIST_EMPTY: ".wishlist__empty",
    WISHLIST_NOT_EMPTY: ".wishlist__not-empty",
    WISHLIST_GRID: ".wishlist__grid",
    WISHLIST_GRID_WRAPPER: ".wishlist__grid--wrapper"
};

});



async function $e6465054b3158371$export$13e9b952682d83de(address) {
    const apiKey = "AIzaSyBnl5SgVn4G03GwG7zKvQCI4dTEBpAwf00";
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`;
    try {
        const response = await fetch(url);
        const data = await response.json();
        if (data.status === "OK") {
            const location = data.results[0].geometry.location;
            return {
                latitude: location.lat,
                longitude: location.lng
            };
        } else {
            console.error("Error geocoding address");
            return {};
        }
    } catch (error) {
        console.error("Error geocoding address");
    }
}


// Make toggleStoreCardList globally available immediately
window.toggleStoreCardList = function() {
    const map = document.querySelector("#map");
    if (map) {
        if (map.style.display === "none") map.style.display = "block";
        else map.style.display = "none";
        if (document.querySelector(".store_cards")) {
            document.querySelector(".store_cards").classList.toggle("hidden");
            if (document.querySelector(".store_map__view-list .map__wrapper")) document.querySelector(".store_map__view-list .map__wrapper").classList.toggle("d-none");
            if (document.querySelector(".store_map__view-list .list__wrapper ")) document.querySelector(".store_map__view-list .list__wrapper ").classList.toggle("d-none");
        }
        const availableCount = document.querySelector(".filter_and_search_stores__available_count");
        if (availableCount) availableCount.classList.toggle("hidden");
        const viewListButton = document.querySelector("button[name='view list']");
        if (viewListButton) viewListButton.classList.toggle("hidden");
    }
};
async function $f53112bbdcda224d$export$9d0b2837dcb8a0a9(mapData) {
    let locations;
    if (sessionStorage.getItem("StoreLocations") && sessionStorage.getItem("StoreLocationsVersion") == "5") {
        locations = JSON.parse(sessionStorage.getItem("StoreLocations"));
        return locations;
    } else {
        // For api fetch
        const storesResp = await fetch("https://netlify.blacklemon.dk/.netlify/functions/getStores?store=ny-form");
        const apiLocations = await storesResp.json();
        if (!mapData) return locations;
        const locations = [
            ...mapData.locations,
            ...apiLocations
        ];
        for (const location1 of locations)if (!location1.address.latitude || !location1.address.longitude) {
            const geocodedAddress = await (0, $e6465054b3158371$export$13e9b952682d83de)(location1.address.address1);
            location1.address.longitude = geocodedAddress.longitude;
            location1.address.latitude = geocodedAddress.latitude;
        }
        sessionStorage.setItem("StoreLocations", JSON.stringify(locations));
        sessionStorage.setItem("StoreLocationsVersion", "5");
        return locations;
    }
}
function $f53112bbdcda224d$export$7e9d0e578cbae0b(text) {
    if (!text) return;
    text = text.replaceAll("\xc3\u02DC", "\xd8").replaceAll("\xc3\xb8", "\xf8").replaceAll("\xc3\xa5", "\xe5").replaceAll("\xc3\xa6", "\xe6").replaceAll("\xc2", "").replaceAll("\xc3\xa9", "\xe9");
    return text;
}
function $f53112bbdcda224d$export$e56470e45d609199(clone, storePhoneNr) {
    if (window.innerWidth >= 750) {
        if (storePhoneNr.includes("+45")) storePhoneNr = storePhoneNr.slice(3);
        let formattedNumber = storePhoneNr.replace(/(\d{2})/g, "$1 ").trim();
        const appendText = "Tlf: ";
        if (clone.querySelector(".call a")) {
            clone.querySelector(".call a").textContent = appendText + formattedNumber;
            const linkbase = "tel:";
            clone.querySelector(".call a").setAttribute("href", linkbase + storePhoneNr);
        }
    } else {
        const linkbase = "tel:";
        if (clone.querySelector(".call a")) clone.querySelector(".call a").setAttribute("href", linkbase + storePhoneNr);
    }
}
function $f53112bbdcda224d$export$117e7a39eefda40d(successCallback, errorCallback) {
    if (navigator.geolocation) navigator.geolocation.getCurrentPosition((position)=>{
        const userPosition = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
        };
        successCallback(userPosition);
    }, (error)=>{
        console.error("Error getting user location:", error);
        errorCallback();
    });
    else {
        console.error("Geolocation is not supported.");
        errorCallback();
    }
}
function $f53112bbdcda224d$export$af470bb618802fb9(openingHours) {
    if (!openingHours || openingHours === "" || !weekdays || !ts_open || !ts_opensoon || !ts_closed) return "";
    const lines = openingHours.split("\n");
    const openinghoursPerDay = {};
    const newDate = new Date();
    const getDateNumber = newDate.getDay() - 1;
    let status = "";
    // Populate opening hours per day
    lines.forEach((line)=>{
        const [key, value] = line.split(": ");
        if (!value) return;
        openinghoursPerDay[key.trim()] = value.trim();
    });
    const openinghoursPerDaysArr = Object.entries(openinghoursPerDay);
    const openinghoursPerDayArr = openinghoursPerDaysArr[getDateNumber];
    if (!openinghoursPerDayArr) return;
    const todaysOpeningHours = openinghoursPerDayArr[1];
    if (!todaysOpeningHours) return "";
    // Handle the case when the place is marked closed for the entire day ("Lukket")
    if (todaysOpeningHours === ts_closed) return '<span class="closed">' + ts_closed + "</span>";
    if (todaysOpeningHours === "00.00 - 00.00") return '<span class="closed">' + ts_closed + "</span>";
    // Parse opening and closing times
    if (!todaysOpeningHours.includes(" - ")) return;
    const [opensAt, closesAt] = todaysOpeningHours.split(" - ");
    const [opensHour, opensMinute] = opensAt.split(".").map(Number);
    const [closesHour, closesMinute] = closesAt.split(".").map(Number);
    // Set comparison times for opening, opening soon and closing
    const openTime = new Date(newDate);
    openTime.setHours(opensHour, opensMinute, 0, 0);
    const openSoonTime = new Date(newDate);
    openTime.setHours(opensHour - 1, opensMinute, 0, 0);
    const closeTime = new Date(newDate);
    closeTime.setHours(closesHour, closesMinute, 0, 0);
    // Check if current time is within the opening hours
    if (newDate >= openTime && newDate < closeTime) {
        status = ts_open;
        statusClass = "open";
    } else if (newDate >= openSoonTime && newDate < closeTime) {
        status = ts_opensoon;
        statusClass = "open-soon";
    } else {
        status = ts_closed;
        statusClass = "closed";
    }
    const openingStatusString = '<span class="' + statusClass + '">' + status + "</span>" + ": " + todaysOpeningHours;
    return openingStatusString;
}
function $f53112bbdcda224d$export$78cef79862f4bf46(clone, storeName) {
    const linkbase = "https://www.google.com/maps/dir//";
    const linkStoreName = storeName.replaceAll(" ", "%20");
    clone.querySelector(".directions a")?.setAttribute("href", linkbase + linkStoreName);
}
function $f53112bbdcda224d$export$ee66e4410e96e51d(location1, userPos) {
    const storeLat = location1["address"]["latitude"];
    const storeLong = location1["address"]["longitude"];
    const userLat = userPos["lat"];
    const userLong = userPos["lng"];
    return $f53112bbdcda224d$var$calculateDistance(storeLat, storeLong, userLat, userLong);
}
function $f53112bbdcda224d$var$calculateDistance(lat1, lon1, lat2, lon2) {
    lat1 = parseFloat(lat1);
    lon1 = parseFloat(lon1);
    lat2 = parseFloat(lat2);
    lon2 = parseFloat(lon2);
    if (isNaN(lat1) || isNaN(lon1) || isNaN(lat2) || isNaN(lon2)) throw new Error("Invalid input: All inputs must be valid numbers");
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = $f53112bbdcda224d$var$deg2rad(lat2 - lat1);
    const dLon = $f53112bbdcda224d$var$deg2rad(lon2 - lon1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos($f53112bbdcda224d$var$deg2rad(lat1)) * Math.cos($f53112bbdcda224d$var$deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = $f53112bbdcda224d$var$roundToTenDecimals(R * c);
    return distance;
}
function $f53112bbdcda224d$var$roundToTenDecimals(num) {
    if (typeof num === "number" && isFinite(num)) return parseFloat(num.toFixed(10));
    else throw new Error("Invalid number");
}
function $f53112bbdcda224d$var$deg2rad(deg) {
    return deg * (Math.PI / 180);
}
window.addEventListener("DOMContentLoaded", async function() {
    if (!location.href.includes("/pages")) return;
    if (!document.querySelector(".store_map__wrapper")) return;
    const denmark = {
        lat: 56.20279,
        lng: 10.25049
    };
    const infoWindows = [];
    let mapData;
    try {
        mapData = JSON.parse(document.querySelector("#map-data").textContent);
    } catch (e) {
        console.error("Error parsing mapData", e);
    }
    const markerImage = mapData.settings.marker_image || "";
    const clusterMarkerImage = mapData.settings.cluster_image ? mapData.settings.cluster_image : "";
    const userMarkerImage = mapData.settings.user_image ? mapData.settings.user_image : "";
    const markerImageSelected = mapData.settings.marker_image_selected ? mapData.settings.marker_image_selected : "";
    const storeT = mapData.settings.store_single ? mapData.settings.store_single : "";
    const storesT = mapData.settings.stores_plural ? mapData.settings.stores_plural : "";
    let pageRedirection;
    if (document.querySelector(".store_cards")) pageRedirection = document.querySelector(".store_cards").getAttribute("store-details-redirection") || "";
    let locations;
    let filteredLocations;
    let map;
    let selectedStoreName = "";
    let mapMarkers = [];
    const selectedStoreZoom = 15;
    const findUserZoom = 10;
    async function initMap(center, zoom, selectedByMarker = false) {
        locations = await $f53112bbdcda224d$export$9d0b2837dcb8a0a9(mapData);
        filteredLocations = locations;
        filteredLocations.forEach((loc)=>{
            let latitude = loc.address.latitude;
            let longitude = loc.address.longitude;
            if (typeof latitude === "string") {
                if (latitude.includes(",")) latitude = latitude.replace(",", ".");
                loc.address.latitude = parseFloat(latitude);
            }
            if (typeof longitude === "string") {
                if (longitude.includes(",")) longitude = longitude.replace(",", ".");
                loc.address.longitude = parseFloat(longitude);
            }
        });
        if (typeof center.lat === "string") {
            if (center.lat.includes(",")) center.lat = center.lat.replace(",", ".");
            center.lat = parseFloat(center.lat);
        }
        if (typeof center.lng === "string") {
            if (center.lng.includes(",")) center.lng = center.lng.replace(",", ".");
            center.lng = parseFloat(center.lng);
        }
        if (isNaN(center.lat) || isNaN(center.lng)) throw new Error("Invalid center coordinates: lat and lng must be valid numbers");
        map = new google.maps.Map(document.getElementById("map"), {
            zoom: zoom,
            center: center,
            mapTypeId: "terrain",
            disableDefaultUI: true,
            styles: [
                {
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#025582"
                        }
                    ]
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#333333"
                        }
                    ]
                },
                {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [
                        {
                            color: "#00283F"
                        }
                    ]
                },
                {
                    featureType: "water",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            color: "#F0EDEB"
                        }
                    ]
                },
                {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [
                        {
                            visibility: "off"
                        }
                    ]
                }
            ]
        });
        removePointsOfInterestFromMap();
        placeMarkers(filteredLocations, markerImage, markerImageSelected, selectedByMarker);
        setupClusters(mapMarkers, clusterMarkerImage);
        initRegionSelect(filteredLocations);
    }
    function removePointsOfInterestFromMap() {
        const styles = {
            hide: [
                {
                    featureType: "poi.business",
                    stylers: [
                        {
                            visibility: "off"
                        }
                    ]
                },
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            visibility: "off"
                        }
                    ]
                }
            ]
        };
    }
    function initRegionSelect(filteredLocations) {
        const uniqueRegions = [
            ...new Set(locations.filter((location1)=>location1.region) // Only include objects with a `region` property
            .map((location1)=>location1.region) // Extract the `region` property
            )
        ];
        const storeMapRegion = document.querySelector(".store_map__region");
        if (!storeMapRegion) return;
        const storeMapRegionTrigger = storeMapRegion.querySelector(".custom-select-trigger");
        if (!storeMapRegionTrigger) return;
        if (uniqueRegions.length == 0) return;
        const storeMapRegionListWrapper = storeMapRegion.querySelector(".custom-options");
        if (!storeMapRegionListWrapper) return;
        storeMapRegionListWrapper.innerHTML = "";
        if (storeMapRegionListWrapper.getAttribute("data-label")) {
            const allLabel = storeMapRegionListWrapper.getAttribute("data-label");
            const liAll = document.createElement("li");
            liAll.setAttribute("data-value", "all");
            liAll.setAttribute("data-label", allLabel);
            liAll.innerText = allLabel;
            storeMapRegionListWrapper.appendChild(liAll);
        }
        uniqueRegions.forEach((region)=>{
            const newList = document.createElement("li");
            newList.setAttribute("data-value", region?.toLowerCase());
            newList.setAttribute("data-label", region);
            newList.innerText = region;
            storeMapRegionListWrapper.appendChild(newList);
        });
        storeMapRegionTrigger.addEventListener("click", function(el) {
            if (!storeMapRegion.classList.contains("open")) storeMapRegion.classList.add("open");
        });
        document.addEventListener("click", (e)=>{
            if (storeMapRegion.classList.contains("open")) {
                if (!storeMapRegion.contains(e.target)) storeMapRegion.classList.remove("open");
            }
        });
        const storeMapRegionLists = storeMapRegionListWrapper.querySelectorAll("li");
        if (!storeMapRegionLists) return;
        const selectTriggerLabel = document.querySelector(".custom-select-trigger span");
        storeMapRegionLists.forEach((mapRegion)=>{
            mapRegion.addEventListener("click", (reg)=>{
                reg.preventDefault();
                const mapRegionData = mapRegion.getAttribute("data-value");
                const mapRegionLabel = mapRegion.getAttribute("data-label");
                if (selectTriggerLabel && mapRegionLabel) selectTriggerLabel.innerText = mapRegionLabel;
                if (document.querySelector(".store_map__region")) document.querySelector(".store_map__region").classList.remove("open");
                if (mapRegionData) {
                    const storeMapInput = document.querySelector(".store_map__search input");
                    if (storeMapInput) storeMapInput.value = "";
                    searchStoreCards("REGION", mapRegionData);
                }
            });
        });
    }
    function initStoreCards() {
        try {
            $f53112bbdcda224d$export$117e7a39eefda40d((userPos)=>{
                const disableLocationEl = document.querySelector(".store_cards__location-disabled");
                if (disableLocationEl) disableLocationEl.classList.add("hidden");
                buildLocationCards(filteredLocations, userPos);
                applyEventListenerOnStoreCards();
                document.querySelector(".icon-localize")?.classList.remove("hidden");
            }, ()=>{
                buildLocationCards(filteredLocations /* You can provide a default user position here if needed */ );
                applyEventListenerOnStoreCards();
            });
        } catch (err) {
            console.warn("error:", err);
        }
        setAvailableStoreCount(filteredLocations);
        //Search eventlisteners
        let typingTimer;
        const doneTypingInterval = 500;
        let input = document.querySelector(".filter_and_search_stores__header input");
        input?.addEventListener("keyup", ()=>{
            clearTimeout(typingTimer);
            typingTimer = setTimeout(decideSearchType, doneTypingInterval);
        });
        input?.addEventListener("keydown", ()=>{
            clearTimeout(typingTimer);
        });
        // localization eventlistener
        document.querySelector(".icon-localize")?.addEventListener("click", localizationPrompt);
        //List eventlisteners
        document.querySelector("button[name='view list']")?.addEventListener("click", toggleStoreCardList);
        document.querySelector("button[name='view map']")?.addEventListener("click", toggleStoreCardList);
    }
    await initMap(denmark, 7.5);
    initStoreCards();
    function localizationPrompt() {
        navigator.permissions.query({
            name: "geolocation"
        }).then((permissionStatus)=>{
            if (permissionStatus.state === "granted") navigator.geolocation.getCurrentPosition((position)=>{
                const latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                deleteMarkers();
                addMarker(latLng, userMarkerImage);
                initMap(latLng, findUserZoom);
            }, (error)=>{
                console.error("Geolocation permission denied or error occurred:", error);
            });
        }).catch((error)=>{
            console.error("Error checking geolocation permission:", error);
        });
    }
    function decideSearchType() {
        const searchTerm = document.querySelector(".filter_and_search_stores__header input").value;
        const searchTermType = typeof searchTerm;
        if (document.querySelector(".store_map__region")) {
            const defaultRegion = document.querySelector('.store_map__region .custom-options li[data-value="all"]');
            if (defaultRegion) {
                const defaultRegionLabel = defaultRegion.getAttribute("data-label");
                const triggerRegionLabel = document.querySelector(".store_map__region .custom-select-trigger span");
                if (defaultRegionLabel && triggerRegionLabel) triggerRegionLabel.innerHTML = defaultRegionLabel;
            }
        }
        if (searchTerm.length > 0 && !isNaN(Number(searchTerm))) searchStoreCards("ZIP", searchTerm);
        else if (searchTerm.length > 0 && searchTermType === "string") searchStoreCards("NAME", searchTerm);
        else if (searchTerm.length == 0) searchStoreCards("RESET");
    }
    function searchStoreCards(type, searchTerm) {
        filteredLocations = locations.map((location1)=>{
            if (location1["name"] === "Shop location") return;
            if (type === "ZIP") {
                if (location1["address"]["zip"].slice(0, searchTerm.length) === searchTerm) return location1;
            } else if (type === "NAME") {
                const searchAgaints = location1["address"]["address1"] + " " + location1["address"]["city"] + " " + location1["name"];
                if (searchAgaints.toUpperCase().includes(searchTerm.toUpperCase())) return location1;
            } else if (type === "REGION") {
                if (searchTerm == "all") return location1;
                else if (location1["region"]) {
                    const searchAgaints = location1["region"];
                    if (searchAgaints.toUpperCase().includes(searchTerm.toUpperCase())) return location1;
                }
            } else if (type === "RESET") return location1;
        });
        document.querySelector(".store_cards").innerHTML = "";
        $f53112bbdcda224d$export$117e7a39eefda40d((userPos)=>{
            buildLocationCards(filteredLocations, userPos);
            applyEventListenerOnStoreCards();
        }, ()=>{
            buildLocationCards(filteredLocations /* You can provide a default user position here if needed */ );
            applyEventListenerOnStoreCards();
        });
        setAvailableStoreCount(filteredLocations);
        deleteMarkers();
        placeMarkers(filteredLocations, markerImage, markerImageSelected);
        setupClusters(mapMarkers, clusterMarkerImage);
    }
    function setMapOnAll(map) {
        map = null;
        for(let i = 0; i < mapMarkers.length; i++)mapMarkers[i].setMap(map);
    }
    function deleteMarkers() {
        setMapOnAll(null);
        mapMarkers = [];
    }
    function findlocationIndex() {
        let i = 0;
        let result;
        if (!filteredLocations) return {};
        filteredLocations.forEach((location1)=>{
            if (location1 == null) i++;
            else if (selectedStoreName.toUpperCase() == $f53112bbdcda224d$export$7e9d0e578cbae0b(location1["name"].toUpperCase())) result = i;
            else i++;
        });
        return result;
    }
    async function placeMarkers(filteredLocations, markerImage, markerImageSelected, selectedByMarker) {
        const selectedStoreIndex = findlocationIndex(selectedStoreName);
        filteredLocations = filteredLocations.filter((location1)=>location1 !== null && location1 !== undefined);
        for (const [i, location1] of filteredLocations.entries()){
            if (location1 === undefined) return;
            let latitude = location1.address.latitude;
            let longitude = location1.address.longitude;
            const latLng = new google.maps.LatLng(latitude, longitude);
            if (selectedStoreIndex == i) {
                const targetStoreCardId = handleizeString(selectedStoreName);
                addMarker(latLng, markerImageSelected, location1);
                if (selectedByMarker) selectCardFromPlaceMarker(selectedStoreName, targetStoreCardId);
            } else addMarker(latLng, markerImage, location1);
        }
    }
    function selectCardFromPlaceMarker(selectedStoreName, selectedStoreNameId) {
        const allStoreCardsArr = Array.from(document.querySelectorAll(".store_card__wrapper"));
        allStoreCardsArr.forEach((storeCard)=>{
            storeCard.setAttribute("data-selected", "false");
        });
        const targettedCard = allStoreCardsArr.find((storeCard)=>storeCard.getAttribute("store-card-id") === selectedStoreNameId);
        targettedCard.setAttribute("data-selected", "true");
    }
    function addMarker(position, image, location1) {
        let mapIcon = document.querySelector(".map_marker svg");
        if (mapIcon) mapIcon = mapIcon.cloneNode(true);
        try {
            const svgString = new XMLSerializer().serializeToString(mapIcon);
            const svgDataUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`;
            const marker = new google.maps.Marker({
                position: position,
                map: map,
                icon: svgDataUrl
            });
            if (location1 != undefined) addMarkerModal(marker, location1);
            mapMarkers.push(marker);
        } catch (e) {
            console.warn("error::", e);
        }
    }
    function setupClusters(markers, clusterMarkerImage) {
        const renderer = {
            render: ({ count: count, position: position })=>new google.maps.Marker({
                    label: {
                        text: String(count),
                        color: "white",
                        fontSize: "10px"
                    },
                    icon: clusterMarkerImage,
                    map: map,
                    position: position,
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
                })
        };
    /*   markers = new MarkerClusterer({ map, markers, renderer }); */ }
    function handleizeString(input) {
        if (typeof input !== "string") throw new Error("HandleizeString input must be type of string!");
        input = input.toLowerCase();
        if (input.includes(" ")) input = input.split(" ").join("-");
        return input;
    }
    function buildLocationCards(filteredLocations, userPos) {
        filteredLocations.map((location1)=>{
            if (location1 == null) return;
            if (location1["name"] == "Shop location") return;
            const template = document.querySelector("#store_card__template");
            const clone = template.content.cloneNode(true);
            const storeName = $f53112bbdcda224d$export$7e9d0e578cbae0b(location1["name"]);
            const storeRoad = $f53112bbdcda224d$export$7e9d0e578cbae0b(location1["address"]["address1"]);
            let storeZip = $f53112bbdcda224d$export$7e9d0e578cbae0b(location1["address"]["zip"]);
            if (storeZip === undefined || storeZip === null) storeZip = $f53112bbdcda224d$export$7e9d0e578cbae0b(location1["address"]["postal_code"]);
            if (storeZip === undefined || storeZip === null) storeZip = ""; // If postal_code and zip are undefined, show empty string
            const storeCardId = handleizeString(storeName);
            clone.querySelector(".store_card__wrapper").setAttribute("store-card-id", storeCardId);
            clone.querySelector(".store_card__wrapper").setAttribute("store-card-sid", location1.storeId);
            const storeCity = $f53112bbdcda224d$export$7e9d0e578cbae0b(location1["address"]["city"]);
            const storeAddress = $f53112bbdcda224d$export$7e9d0e578cbae0b(storeRoad) + ", " + storeZip + " " + $f53112bbdcda224d$export$7e9d0e578cbae0b(storeCity);
            const storePhoneNr = location1["address"]["phone"];
            const openingHours = location1.openingHours;
            const openingStatusText = $f53112bbdcda224d$export$af470bb618802fb9(location1.openingHours);
            if (userPos) {
                const storeDistance = $f53112bbdcda224d$export$ee66e4410e96e51d(location1, userPos);
                clone.querySelector(".store_card__shop_distance span").innerText = storeDistance ? storeDistance.toFixed(2) : "";
            } else clone.querySelector(".store_card__shop_distance").classList.add("hidden");
            clone.querySelector(".store_card__shop_name").innerText = storeName ? storeName : "";
            clone.querySelector(".store_card__shop_address").innerText = storeAddress ? storeAddress : "";
            clone.querySelector(".store_card__shop_info").innerText = openingHours ? openingHours : "";
            clone.querySelector(".store_card__shop_current_opening_status").innerHTML = openingStatusText ? openingStatusText : "";
            setStoreSoMeLinks(clone, location1);
            $f53112bbdcda224d$export$78cef79862f4bf46(clone, storeName);
            $f53112bbdcda224d$export$e56470e45d609199(clone, storePhoneNr);
            document.querySelector(".store_cards").appendChild(clone);
            if (selectedStoreName != "" && storeName.toUpperCase() === selectedStoreName.toUpperCase()) document.querySelector(".store_cards .store_card__wrapper:last-of-type").dataset.selected = true;
        });
    }
    function setStoreSoMeLinks(clone, location1) {
        let instagramLink = "";
        let facebookLink = "";
        if (!location1.metafields) return;
        location1.metafields.forEach((metafield)=>{
            if (metafield.key === "facebook_link") facebookLink = metafield.value;
            else if (metafield.key === "instagram_link") instagramLink = metafield.value;
        });
        if (instagramLink != "") clone.querySelector(".social_links .instagram_link").setAttribute("href", instagramLink);
        if (facebookLink != "") clone.querySelector(".social_links .facebook_link").setAttribute("href", facebookLink);
    }
    function openStoreDetails(selectedStoreId) {
        if (selectedStoreId) {
            if (window.location.href.includes("de-de")) window.location = window.origin + "/de-de" + pageRedirection + "?storeId=" + selectedStoreId;
            else window.location = window.origin + pageRedirection + "?storeId=" + selectedStoreId;
        }
    }
    function applyEventListenerOnStoreCards() {
        document.querySelectorAll(".store_card__wrapper").forEach((store_card)=>{
            store_card.addEventListener("click", selectStoreFromCards.bind(store_card));
        });
    }
    function selectStoreFromCards(ev) {
        const target = ev.target;
        if (target.closest(".store_card__icons") || target.classList.contains(".store_card__icons")) return;
        const selectedStore = this;
        document.querySelectorAll(".store_card__wrapper").forEach((store_card)=>{
            store_card.dataset.selected = false;
        });
        selectedStoreName = selectedStore.querySelector(".store_card__shop_name").innerText;
        selectedStore.dataset.selected = true;
        const selectedStoreId = selectedStore.getAttribute("store-card-sid") || "";
        openStoreDetails(selectedStoreId);
        if (window.innerWidth < 750) {
            deleteContentFromSelectedStoreMapCard();
            document.querySelectorAll(".store_cards .store_card__wrapper").forEach((card)=>{
                if (card.querySelector(".store_card__shop_name").innerText.toUpperCase() == $f53112bbdcda224d$export$7e9d0e578cbae0b(selectedStoreName.toUpperCase())) {
                    let clone = card.cloneNode(true);
                    document.querySelector(".selected_store_map_card").appendChild(clone);
                    document.querySelector(".selected_store_map_card .icon-close").addEventListener("click", removeSelectedStoreCardOverlay);
                    document.querySelector(".selected_store_map_card").classList.remove("hidden");
                    document.querySelector(".selected_store_map_card").querySelector("[data-buttons]").classList.add("flex-wrap", "overflow-x-auto");
                }
            });
        }
    }
    function deleteContentFromSelectedStoreMapCard() {
        if (document.querySelector(".selected_store_map_card .store_card__wrapper")) document.querySelector(".selected_store_map_card .store_card__wrapper").remove();
    }
    function setAvailableStoreCount(filteredLocations) {
        let count = 0;
        for(node in filteredLocations){
            if (filteredLocations[node] == null) continue;
            if (filteredLocations[node]["name"] == "Shop location") continue;
            count++;
        }
        let translationstring;
        if (count == 1) translationstring = storeT;
        else translationstring = storesT;
        document.querySelector(".filter_and_search_stores__available_count span").innerText = count + " " + translationstring;
    }
    function addMarkerModal(marker, location1) {
        const storeName = location1["name"] ? $f53112bbdcda224d$export$7e9d0e578cbae0b(location1["name"]) : "";
        const storeRoad = location1["address"]["address1"] ? $f53112bbdcda224d$export$7e9d0e578cbae0b(location1["address"]["address1"]) : "";
        const storeZip = location1["address"]["zip"] ? $f53112bbdcda224d$export$7e9d0e578cbae0b(location1["address"]["zip"]) : "";
        const storeCity = location1["address"]["city"] ? $f53112bbdcda224d$export$7e9d0e578cbae0b(location1["address"]["city"]) : "";
        const storeAddress = $f53112bbdcda224d$export$7e9d0e578cbae0b(storeRoad) + ", " + storeZip + " " + $f53112bbdcda224d$export$7e9d0e578cbae0b(storeCity);
        const contentString = '<div class="map-card"><b class="map-header">' + storeName + "</b><br />" + storeAddress + "<br /></div>";
        const infowindow = new google.maps.InfoWindow({
            content: contentString,
            maxWidth: 300
        });
        infoWindows.push(infowindow);
        marker.addListener("click", ()=>{
            document.querySelectorAll(".store_card__wrapper").forEach((store_card)=>{
                store_card.dataset.selected = false;
            });
            if (isInfoWindowOpen(infowindow)) {
                if (infowindow.anchor != marker) {
                    closeAllInfoWindows(infoWindows);
                    infowindow.open(map, marker);
                } else infowindow.close();
            } else {
                closeAllInfoWindows(infoWindows);
                infowindow.open(map, marker);
            }
            setTimeout(()=>{
                setupSelectStoreByMarker();
            }, "500");
        });
    }
    function setupSelectStoreByMarker() {
        document.querySelectorAll(".store_card__wrapper").forEach((store_card)=>{
            store_card.dataset.selected = false;
        });
        document.querySelectorAll(".selected_store_page__services__wrapper .service_card").forEach((card)=>{
            if (!card.classList.contains("hidden")) card.classList.add("hidden");
        });
        if (document.querySelector(".selected_store_page__services")) document.querySelector(".selected_store_page__services").classList.add("hidden");
        let selectedStoreId;
        const selectedStore = document.querySelector(".map-header");
        if (!selectedStore) return;
        selectedStoreName = selectedStore.innerText;
        document.querySelectorAll(".store_card__wrapper").forEach((card)=>{
            if (card.querySelector(".store_card__shop_name").innerText.toUpperCase() == $f53112bbdcda224d$export$7e9d0e578cbae0b(selectedStoreName.toUpperCase())) {
                selectedStoreId = card.getAttribute("store-card-sid") || "";
                card.dataset.selected = true;
            }
        });
        const storeIndex = findlocationIndex();
        const latlng = {
            lat: filteredLocations[storeIndex]["address"]["latitude"],
            lng: filteredLocations[storeIndex]["address"]["longitude"]
        };
        deleteMarkers();
        initMap(latlng, selectedStoreZoom, true);
        if (window.innerWidth < 750) {
            deleteContentFromSelectedStoreMapCard();
            document.querySelectorAll(".store_card__wrapper").forEach((card)=>{
                if (card.querySelector(".store_card__shop_name ").innerText.toUpperCase() == $f53112bbdcda224d$export$7e9d0e578cbae0b(selectedStoreName.toUpperCase())) {
                    let clone = card.cloneNode(true);
                    document.querySelector(".selected_store_map_card").appendChild(clone);
                    const iconCloseElement = document.querySelector(".selected_store_map_card .icon-close");
                    if (iconCloseElement) iconCloseElement.addEventListener("click", removeSelectedStoreCardOverlay);
                    document.querySelector(".selected_store_map_card .open_store_page").addEventListener("click", function() {
                        openStoreDetails(selectedStoreId);
                    });
                    document.querySelector(".selected_store_map_card").classList.remove("hidden");
                    document.querySelector(".selected_store_map_card").querySelector("[data-buttons]").classList.add("overflow-x-auto", "pb-1");
                }
            });
        }
        openStoreDetails(selectedStoreId);
    }
    function removeSelectedStoreCardOverlay() {
        document.querySelector(".selected_store_map_card .store_card__wrapper").remove();
        document.querySelector(".selected_store_map_card").classList.add("hidden");
    }
    function isInfoWindowOpen(infowindow) {
        var map = infowindow.getMap();
        return map !== null && typeof map !== "undefined";
    }
    function closeAllInfoWindows(infoWindows) {
        for(var i = 0; i < infoWindows.length; i++)infoWindows[i].close();
    }
});



if (!customElements.get("store-details")) {
    class StoreDetails extends HTMLElement {
        constructor(){
            super();
            this.el = this;
            const urlParams = new URLSearchParams(window.location.search);
            this.storeId = urlParams.get("storeId");
            if (!this.storeId) this.storeNotFound();
            if (!this.storeId) return;
            this.init();
        }
        async init() {
            const locations = await this.fetchStores();
            await this.initStore(locations);
        }
        async initStore(locations) {
            const location = locations.find((location)=>location.storeId === this.storeId);
            if (!location) this.storeNotFound();
            if (!location) return;
            const storeName = (0, $f53112bbdcda224d$export$7e9d0e578cbae0b)(location["name"]);
            const storeRoad = (0, $f53112bbdcda224d$export$7e9d0e578cbae0b)(location["address"]["address1"]);
            let storeZip = (0, $f53112bbdcda224d$export$7e9d0e578cbae0b)(location["address"]["zip"]);
            if (storeZip === undefined || storeZip === null) storeZip = (0, $f53112bbdcda224d$export$7e9d0e578cbae0b)(location["address"]["postal_code"]);
            if (storeZip === undefined || storeZip === null) storeZip = "";
            let address2 = (0, $f53112bbdcda224d$export$7e9d0e578cbae0b)(location["address"]["address2"]);
            if (address2 === undefined || storeZip === null) address2 = (0, $f53112bbdcda224d$export$7e9d0e578cbae0b)(location["address"]["address2"]);
            if (address2 === undefined || storeZip === null) address2 = "";
            const storeCity = (0, $f53112bbdcda224d$export$7e9d0e578cbae0b)(location["address"]["city"]);
            const storeAddress = (0, $f53112bbdcda224d$export$7e9d0e578cbae0b)(storeRoad) + ", " + address2 + " " + storeZip + " " + (0, $f53112bbdcda224d$export$7e9d0e578cbae0b)(storeCity);
            const storePhoneNr = location["address"]["phone"];
            const openingHours = location.openingHours;
            const storeEmail = location["email"];
            this.el.querySelector(".store_card__shop_name").innerText = storeName ? storeName : "";
            this.el.querySelector(".store_card__shop_address").innerText = storeAddress ? storeAddress : "";
            const storePosition = {
                lat: location["address"]["latitude"],
                lng: location["address"]["longitude"]
            };
            const storeEmailElement = this.el.querySelector(".store_card__shop_email");
            if (storeEmail && storeEmailElement) {
                storeEmailElement.innerText = storeEmail;
                storeEmailElement.closest("a").setAttribute("href", `mailto:${storeEmail}`);
            }
            const openingStatusText = (0, $f53112bbdcda224d$export$af470bb618802fb9)(location.openingHours);
            const openingHoursHtml = this.wrapFirstWord(openingHours);
            this.el.querySelector(".store_card__shop_info").innerHTML = openingHoursHtml ? openingHoursHtml : "";
            this.el.querySelector(".store_card__shop_current_opening_status").innerHTML = openingStatusText ? openingStatusText : "";
            (0, $f53112bbdcda224d$export$78cef79862f4bf46)(this.el, storeAddress);
            this.initCall(this.el, storePhoneNr);
            this.initDirections();
            this.updateBreadcrumbs(storeName);
            this.showStorePage();
            const map = this.initializeMap(storePosition);
            const mapPosition = new google.maps.LatLng(storePosition.lat, storePosition.lng, map);
            this.addMarker(mapPosition, map);
            await this.userLocation(location);
        }
        initializeMap(storePosition) {
            const map = new google.maps.Map(document.getElementById("map"), {
                zoom: 15,
                center: storePosition,
                mapTypeId: "terrain",
                disableDefaultUI: true,
                styles: [
                    {
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#025582"
                            }
                        ]
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#333333"
                            }
                        ]
                    },
                    {
                        featureType: "road",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#00283F"
                            }
                        ]
                    },
                    {
                        featureType: "water",
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#F0EDEB"
                            }
                        ]
                    },
                    {
                        featureType: "poi",
                        elementType: "geometry",
                        stylers: [
                            {
                                visibility: "off"
                            }
                        ]
                    }
                ]
            });
            return map;
        }
        initCall(el, storePhoneNr) {
            let storePhonePrefix = "";
            if (storePhoneNr && el.querySelector(".store_card__shop_phone")) {
                if (storePhoneNr.includes("+45")) {
                    storePhonePrefix = storePhoneNr.slice(0, 3);
                    storePhoneNr = storePhoneNr.slice(3);
                }
                const storePhoneElement = this.el.querySelector(".store_card__shop_phone");
                if (!storePhoneElement) return;
                storePhoneElement.innerText = storePhonePrefix + " " + storePhoneNr;
                storePhoneElement.closest("a").setAttribute("href", `tel: ${storePhonePrefix + " " + storePhoneNr}`);
            }
            const call = document.querySelector(".call");
            if (call) {
                const callLink = call.querySelector("a");
                if (callLink) {
                    callLink.setAttribute("href", `tel:${storePhoneNr}`);
                    call.addEventListener("click", function() {
                        const callLinkHref = callLink.getAttribute("href");
                        window.open(callLinkHref);
                    });
                }
            }
        }
        updateBreadcrumbs(storeName) {
            const breadcrumbs = document.querySelectorAll("nav.breadcrumbs");
            if (breadcrumbs) breadcrumbs.forEach((breadcrumb)=>{
                const breadcrumbsCurrent = breadcrumb.querySelector(".breadcrumbs__current");
                if (breadcrumbsCurrent) breadcrumbsCurrent.innerText = storeName;
            });
        }
        initDirections() {
            const directions = document.querySelector(".directions");
            if (directions) directions.addEventListener("click", function() {
                const directionsLink = directions.querySelector("a");
                if (directionsLink) {
                    const directionsLinkHref = directionsLink.getAttribute("href");
                    window.open(directionsLinkHref, "_blank");
                }
            });
        }
        async userLocation(location) {
            try {
                const userLocationObj = await this.findUserLocation();
                if (userLocationObj !== null) {
                    const userLocation = {
                        lat: userLocationObj.coords.latitude,
                        lng: userLocationObj.coords.longitude
                    };
                    const storeDistance = (0, $f53112bbdcda224d$export$ee66e4410e96e51d)(location, userLocation);
                    this.el.querySelector(".store_card__shop_distance span").innerText = storeDistance ? storeDistance.toFixed(2) : "";
                }
            } catch (e) {
                this.el.querySelector(".store_card__shop_distance").classList.add("d-none");
                throw new Error("Error while fetching user location", e);
            }
        }
        addMarker(position, map) {
            const mapIcon = document.querySelector(".map_marker svg");
            try {
                const svgString = new XMLSerializer().serializeToString(mapIcon);
                const svgDataUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`;
                const marker = new google.maps.Marker({
                    position: position,
                    map: map,
                    icon: svgDataUrl
                });
            } catch (e) {
                console.warn("error::", e);
            }
        }
        showStorePage() {
            if (document.querySelector(".store_card__wrapper--left .store__content--wrapper")) document.querySelector(".store__content--wrapper").classList.remove("d-none");
        }
        wrapFirstWord(text) {
            if (typeof text !== "string") throw new Error("Input must be a string");
            return text.split("\n").map((line)=>{
                if (!line.trim()) return line;
                const [firstWord, ...rest] = line.split(" ");
                if (!firstWord) return line;
                return `<div><span class="first-word">${firstWord}</span> <span class="rest">${rest.join(" ")}</span></div>`;
            }).join("\n");
        }
        storeNotFound() {
            if (document.querySelector("store-details")) document.querySelector("store-details").insertAdjacentHTML("beforeend", `<h1 class='store-not-found'> ${theme.strings.store_not_found}</h1>`);
        }
        async getUserLocation() {
            try {
                const position = await findUserLocation();
            } catch (error) {
                console.error("Error fetching location:", error);
            }
        }
        findUserLocation() {
            return new Promise((resolve, reject)=>{
                if (navigator.geolocation) navigator.geolocation.getCurrentPosition((position)=>resolve(position), (error)=>reject(error) // Error callback
                );
                else reject(new Error("Geolocation is not supported by this browser."));
            });
        }
        async fetchStores() {
            try {
                const storesResp = await fetch("https://netlify.blacklemon.dk/.netlify/functions/getStores?store=ny-form");
                const apiLocations = await storesResp.json();
                return apiLocations;
            } catch (e) {
                throw new Error("Could not fetch location data", e);
            }
        }
    }
    customElements.define("store-details", StoreDetails);
}


parcelRequire("eYUK7");
parcelRequire("iZdAF");
parcelRequire("6r3w3");
if (!customElements.get("connected-products")) {
    class ConnectedProducts extends HTMLElement {
        constructor(){
            super();
            this.el = this;
            this.mainProductHandle = this.el.dataset.mainProductHandle;
            this.useJavascript = this.el.dataset.useJavascript == "true";
            if (this.useJavascript) this.getConnectedProductsHtml(this.mainProductHandle);
        }
        initFlickitySwatches() {
            const sliders = document.querySelectorAll(".product-grid-item__swatches-slider");
            if (!sliders.length) return;
            const Flickity = window.themeVendor?.Flickity;
            sliders.forEach((slider)=>{
                const items = slider.querySelectorAll(".product-grid-item__swatches-slider__item");
                if (items.length > 5) {
                    const sl = new Flickity(slider, {
                        wrapAround: false,
                        pageDots: false,
                        prevNextButtons: false,
                        cellAlign: "left"
                    });
                }
            });
        }
        async getConnectedProductsHtml(handle) {
            const connectedProductHref = `${window.theme?.routes?.root}products/${handle}?view=connected-products`;
            document.dispatchEvent(new CustomEvent("connected-products-fetching", {
                bubbles: true
            }));
            try {
                const resp = await fetch(connectedProductHref, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                });
                if (!resp.ok) throw new Error(`Failed to fetch connected products. Status: ${resp.status}`);
                const responseText = await resp.text();
                const respDOM = new DOMParser().parseFromString(responseText, "text/html");
                const fetchedConnectedProducts = respDOM.querySelector("connected-products").cloneNode(true);
                if (this.el) {
                    this.el.innerHTML = fetchedConnectedProducts.innerHTML;
                    this.initFlickitySwatches();
                    this.initHoverSwitching();
                }
            } catch (error) {
                console.error(`Error fetching connected products: ${error.message}`);
            }
        }
        initHoverSwitching() {
            const connectedProductItems = this.querySelectorAll(".product-grid-item__swatches-slider__item");
            connectedProductItems?.forEach((connectedProduct)=>{
                this.cardWrapper = connectedProduct.closest(".product-grid-item");
                this.cardImages = this.cardWrapper?.querySelectorAll("figure.product__media img");
                this.mainProdSrcSetAll = Array.from(this.cardImages || []).map((image)=>image.getAttribute("srcset"));
                this.sizesEl = this.cardWrapper?.querySelector(".product-grid-items__sizes");
                this.mainProdSize = this.sizesEl ? this.sizesEl.innerHTML : null;
                connectedProduct.addEventListener("mouseenter", this.setProductCardToConnectedProduct.bind(this, connectedProduct));
                connectedProduct.addEventListener("mouseleave", this.unsetProductCardToConnectedProduct.bind(this));
            });
        }
        setProductCardToConnectedProduct(connectedProduct) {
            const newImage = connectedProduct.dataset?.image;
            if (newImage) this.cardImages?.forEach((image)=>{
                image.setAttribute("srcset", newImage);
            });
            const connectedSizes = connectedProduct.dataset?.sizes;
            if (connectedSizes && this.mainProdSize && this.sizesEl) this.sizesEl.innerHTML = connectedSizes;
        }
        unsetProductCardToConnectedProduct() {
            if (this.mainProdSrcSetAll && this.mainProdSrcSetAll.length && this.mainProdSrcSetAll.length === this.cardImages.length) this.cardImages?.forEach((image, index)=>{
                image.setAttribute("srcset", this.mainProdSrcSetAll[index]);
            });
            if (this.mainProdSize && this.sizesEl) this.sizesEl.innerHTML = this.mainProdSize;
        }
    }
    customElements.define("connected-products", ConnectedProducts);
}


parcelRequire("kjMEF");
var $a2a4018f5e776917$export$2e2bcd8739ae039 = SELECTORS = {
    productTypeVariant: ".product__selectors .radio__button input",
    PDPRecipientFormCheckbox: "recipient-form input[data-recipient-checkbox]",
    PDPGiftCardTypeVariantOptions: "[data-product-info] .product__selectors .gift-card-type-button",
    PDPAmountVariant: ".product__selectors [is-amount-variant]"
};


function $95bffaf145104add$var$handleGiftCardForm() {
    const recipientFormCheckbox = document.querySelector((0, $a2a4018f5e776917$export$2e2bcd8739ae039).PDPRecipientFormCheckbox);
    if (!recipientFormCheckbox) return;
    // Hide the label next to the recipient checkbox (optional UI tweak)
    const recipientFormCheckboxLabel = document.querySelector(`#${recipientFormCheckbox.id} + label`);
    if (recipientFormCheckboxLabel) recipientFormCheckboxLabel.classList.add("d-none");
    const giftCardTypes = document.querySelectorAll((0, $a2a4018f5e776917$export$2e2bcd8739ae039).productTypeVariant);
    if (!giftCardTypes.length) return;
    const updateRecipientFormVisibility = ()=>{
        const selectedType = [
            ...giftCardTypes
        ].find((input)=>input.checked)?.value;
        if (selectedType === "Email") {
            if (!recipientFormCheckbox.checked) recipientFormCheckbox.click(); // Ensure it's visible
        } else if (recipientFormCheckbox.checked) recipientFormCheckbox.click(); // Hide it
    };
    // Attach event listener to all gift card type inputs
    giftCardTypes.forEach((input)=>{
        input.addEventListener("change", updateRecipientFormVisibility);
    });
    // Run initially on page load
    updateRecipientFormVisibility();
}
function $95bffaf145104add$var$handleAmountDropdown() {
    const PDPGiftCardTypeVariantOptions = document.querySelectorAll((0, $a2a4018f5e776917$export$2e2bcd8739ae039).PDPGiftCardTypeVariantOptions);
    const PDPAmountVariant = document.querySelector((0, $a2a4018f5e776917$export$2e2bcd8739ae039).PDPAmountVariant);
    if (!PDPGiftCardTypeVariantOptions || !PDPAmountVariant) return;
    PDPGiftCardTypeVariantOptions.forEach((option)=>{
        if (option.hasAttribute("show-amount-full-width")) {
            const input = option.parentElement.querySelector("input");
            if (input && input.checked) PDPAmountVariant.classList.add("full-width");
        }
        option.addEventListener("click", ()=>{
            if (option.hasAttribute("show-amount-full-width")) PDPAmountVariant.classList.add("full-width");
            else PDPAmountVariant.classList.remove("full-width");
        });
    });
}
$95bffaf145104add$var$handleGiftCardForm();
$95bffaf145104add$var$handleAmountDropdown();


parcelRequire("kGGAg");
function $54e7cb4d7e3ecbe9$var$initImageGallery(imageGallery) {
    if (!imageGallery) return;
    const mainImage = imageGallery.querySelector(".main-image");
    const subImages = imageGallery.querySelectorAll(".sub-images--wrapper .sub-image");
    if (!mainImage || !subImages) return;
    subImages.forEach((subImage)=>{
        subImage.addEventListener("click", ()=>$54e7cb4d7e3ecbe9$var$triggerImageGallery(imageGallery, mainImage, subImage));
    });
}
function $54e7cb4d7e3ecbe9$var$triggerImageGallery(imageGallery, mainImage, subImage) {
    imageGallery.querySelectorAll(".sub-images--wrapper .sub-image img").forEach((el)=>el.classList.remove("active"));
    const currentSubImage = subImage.querySelector("img");
    currentSubImage.classList.add("active");
    if (!currentSubImage) return;
    const currentSubImageId = currentSubImage.getAttribute("image-id");
    const mainImageId = mainImage.querySelector("img").getAttribute("image-id");
    if (currentSubImageId !== mainImageId) {
        const clonedSubimage = currentSubImage.cloneNode(true);
        mainImage.replaceChildren(clonedSubimage);
    }
}
const $54e7cb4d7e3ecbe9$var$imageGalleries = document.querySelectorAll(".image-gallery__wrapper");
if ($54e7cb4d7e3ecbe9$var$imageGalleries) $54e7cb4d7e3ecbe9$var$imageGalleries.forEach((imageGallery)=>$54e7cb4d7e3ecbe9$var$initImageGallery(imageGallery));


document.addEventListener("theme:cart:loaded", $0612f835c2821702$var$addGiftCheckboxEvent);
document.addEventListener("theme:cart:added", $0612f835c2821702$var$addGiftCheckboxEvent);
function $0612f835c2821702$var$addGiftCheckboxEvent() {
    const cartItems = document.querySelectorAll(".cart__item");
    cartItems.forEach((cartItem)=>{
        const giftCheckbox = cartItem.querySelector(`#is-gift-${cartItem.dataset.item.split(":")[0]}`);
        giftCheckbox?.addEventListener("change", async (ev)=>{
            const lineItemId = cartItem.dataset.item.split(":")[0];
            const giftProperty = ev.target.checked;
            await $0612f835c2821702$var$updateLineItemGiftProperty(lineItemId, giftProperty);
            document.dispatchEvent(new CustomEvent("theme:cart:add"));
        });
    });
}
async function $0612f835c2821702$var$updateLineItemGiftProperty(lineItemId, giftProperty) {
    try {
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();
        const lineItemIdNumber = parseInt(lineItemId);
        const lineItem = cartData.items.find((item)=>item.id === lineItemIdNumber);
        if (!lineItem) return;
        return await fetch("/cart/change", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id: lineItemId,
                quantity: lineItem.quantity,
                properties: {
                    ...lineItem?.properties,
                    "_isGift": giftProperty
                }
            })
        });
    } catch (error) {
        console.error("Error updating line item gift property", error);
    }
}


function $9f56b0c36d74659e$var$determineEligibilityOfMembersPrice() {
    const isUserLoggedIn = window.customer?.isLoggedIn;
    try {
        let isUserLoggedInLocalStorage = localStorage.getItem("isUserLoggedIn") || "false";
        isUserLoggedInLocalStorage = JSON.parse(isUserLoggedInLocalStorage);
        if (isUserLoggedInLocalStorage === null || isUserLoggedInLocalStorage === undefined || isUserLoggedInLocalStorage !== isUserLoggedIn) {
            localStorage.setItem("isUserLoggedIn", isUserLoggedIn);
            $9f56b0c36d74659e$var$changeEligibilityOfMembersPrice(isUserLoggedIn);
        }
    } catch (error) {
        console.error("\u274C Error determining eligibility of members price:", error);
    }
}
async function $9f56b0c36d74659e$var$changeEligibilityOfMembersPrice(isUserLoggedIn) {
    if (isUserLoggedIn === null || isUserLoggedIn === undefined) return;
    $9f56b0c36d74659e$var$toggleDisabilityCartDrawerIcon(true);
    const isUserLoggedInString = isUserLoggedIn ? "true" : "false";
    try {
        let cartItems = (await fetch("/cart.js").then((r)=>r.json())).items;
        while(true){
            // Find the next item that needs updating
            const itemToUpdate = cartItems.find((item)=>{
                const currentValue = item.properties?._is_user_logged_in;
                return currentValue !== isUserLoggedInString;
            });
            if (!itemToUpdate) break;
            const updatedProperties = {};
            for(const key in itemToUpdate.properties){
                const val = itemToUpdate.properties[key];
                if (val !== undefined) updatedProperties[key] = typeof val === "string" ? val : String(val ?? "");
            }
            updatedProperties["_is_user_logged_in"] = isUserLoggedInString;
            const response = await fetch("/cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id: itemToUpdate.key,
                    quantity: itemToUpdate.quantity,
                    properties: updatedProperties
                })
            });
            const result = await response.json();
            // Refetch cart to get fresh keys after change
            cartItems = (await fetch("/cart.js").then((r)=>r.json())).items;
        }
        $9f56b0c36d74659e$var$toggleDisabilityCartDrawerIcon(false);
        window.location.href = window.location.href;
    } catch (err) {
        console.error("\u274C Error updating cart items:", err);
    }
}
function $9f56b0c36d74659e$var$toggleDisabilityCartDrawerIcon(disabled) {
    const cartDrawerIcon = document.querySelector(".menu__item--secondary [data-cart-drawer-toggle]");
    if (cartDrawerIcon) cartDrawerIcon.classList.toggle("disabled", disabled);
}
document.addEventListener("DOMContentLoaded", ()=>{
    $9f56b0c36d74659e$var$determineEligibilityOfMembersPrice();
});



})();
//# sourceMappingURL=parcel_scripts.js.map
